import Modal from "aldoo-ra/Modal"

export default function ShoppingCart({ store }) {
  const { getFragment, cart, cartVisible, hideCart } = store

  const EmptyCart = getFragment("shopping-cart-empty")
  const ShoppingCartProductList = getFragment("shopping-cart-product-list")
  const ShoppingCartFooter = getFragment("shopping-cart-footer")
  const ShoppingCartTitle = getFragment("shopping-cart-title")

  if (!cartVisible) return null

  return (
    <Modal
      title={<ShoppingCartTitle store={store} />}
      isOpen={cartVisible}
      variant="centered"
      className="md:max-w-[560px]"
      styleOverrides={{
        title: "mb-6 md:mb-0",
      }}
      onClose={hideCart}
      footerContent={cart.length > 0 ? <ShoppingCartFooter store={store} /> : null}
    >
      {cart.length === 0 && <EmptyCart store={store} />}
      {cart.length > 0 && <ShoppingCartProductList store={store} />}
    </Modal>
  )
}
